// extracted by mini-css-extract-plugin
export default {"modalFooterAction":"AssessmentOtherLearningGoals__modalFooterAction___lJBw8","modalFooterContainer":"AssessmentOtherLearningGoals__modalFooterContainer___Y8uad"};